import { useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { Img } from 'root/src/client/v2/common/components/ui/image';
// Image that fades in once loaded, to avoid a hard pop-in as cards scroll into view.
// Owns the opacity/transform transition so callers can still add hover transforms (e.g. scale).
export const FadeInImage = ({ src, alt, className, onError }) => {
    const reduceMotion = useReducedMotion();
    const [loaded, setLoaded] = useState(false);
    const visible = loaded || Boolean(reduceMotion);
    return (<Img src={src} alt={alt} loading="lazy" onLoad={() => setLoaded(true)} onError={onError} className={cn('transition-[opacity,transform] duration-500', visible ? 'opacity-100' : 'opacity-0', className)}/>);
};
